var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z",
    fill: "#A5B4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2311 16.9403C35.8123 17.7329 35.6824 18.8002 35.1457 19.6237C30.813 26.2717 27.5594 30.598 25.5287 33.1244C24.1986 34.7794 21.83 34.9027 20.318 33.4122C18.4534 31.5742 15.8474 28.8431 13.1494 25.4994C12.4359 24.6152 12.2884 23.3741 12.9859 22.4772C13.5319 21.7752 14.1475 21.1663 14.7145 20.6729C15.7632 19.7605 17.2997 19.9646 18.2463 20.9825C20.9745 23.9162 22.6154 25.9565 22.6154 25.9565C22.6154 25.9565 25.3443 21.9168 29.7273 15.6937C30.4451 14.6745 31.738 14.1987 32.817 14.8229C33.6119 15.2828 34.5158 15.9648 35.2311 16.9403Z",
    fill: "#4F46E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4a7dfc6d2f049fda44767910395510dc.svg";
export { ForwardRef as ReactComponent };